/* Viretta index.v2 – front page behaviour: hero slides (one film at a time, each plays once then the next fades in; pause, arrows, thumbnails
   ; photos 9 s), bestseller tabs, Shōjin cards (hover film pauses the ritual film). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function playVid(v) { if (!v) return; var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  // owner 9 Oct (round 9): on desktop the film + »Shop efter kategori« fill the screen exactly – »Topvalg nu« starts just
  // below the fold on any desktop height. Phones keep the CSS height.
  function fitHero(root) {
    var fit = function () {
      if (window.innerWidth < 1000) { root.style.height = ''; return; }
      var sec = root.closest('.shopify-section') || root;
      var next = sec.nextElementSibling;
      var cats = next ? (next.querySelector('.v2-hc') || (next.classList.contains('v2-hc') ? next : null)) : null;
      var catsH = cats ? Math.round(cats.getBoundingClientRect().height) : 0;
      var top = Math.round(root.getBoundingClientRect().top + window.scrollY);
      var h = window.innerHeight - top - catsH;
      root.style.height = Math.max(520, Math.min(1100, h)) + 'px';
    };
    fit();
    var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 100); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    window.addEventListener('load', fit);
  }

  function initHero(root) {
    if (root.dataset.v2Init) return; root.dataset.v2Init = '1';
    fitHero(root);
    var slides = root.querySelectorAll('[data-v2-slide]');
    var txts = root.querySelectorAll('[data-v2-slidetxt]');
    var thumbs = root.querySelectorAll('[data-v2-goto]');
    var labels = []; try { labels = JSON.parse((root.querySelector('[data-v2-nextlabels]') || {}).textContent || '[]'); } catch (e) {}
    var nextTitle = root.querySelector('[data-v2-nexttitle]');
    var pauseBtn = root.querySelector('[data-v2-pause]');
    // Films play like on LIVE (also with reduced motion – the pause button stops them); each film plays once and the
    // next slide fades in when it ends. Photos, or a film that cannot start, move on after 9 s.
    var cur = 0, paused = false, timer = null;
    var phone = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };
    function vidOf(i) {
      if (!slides[i]) return null;
      var vs = slides[i].querySelectorAll('video'); if (vs.length < 2) return vs[0] || null;
      return phone.matches ? (slides[i].querySelector('.v2-hero__vid--m') || vs[0]) : (slides[i].querySelector('.v2-hero__vid--d') || vs[0]);
    }
    function start(v) {
      if (!v) return;
      try { if (v.ended || v.currentTime > 0) v.currentTime = 0; } catch (e) {}
      var p = v.play(); if (p && p.catch) p.catch(function () { arm(9000); });
    }
    function show(i) {
      var n = slides.length; if (!n) return;
      i = (i + n) % n;
      for (var k = 0; k < n; k++) {
        var on = k === i;
        slides[k].classList.toggle('is-on', on);
        if (txts[k]) { txts[k].classList.toggle('is-on', on); txts[k].setAttribute('aria-hidden', on ? 'false' : 'true'); txts[k].inert = !on; }
        if (thumbs[k]) thumbs[k].classList.toggle('is-on', on);
        slides[k].querySelectorAll('video').forEach(function (v) { if (!on) v.pause(); });
      }
      cur = i;
      if (nextTitle && n > 1) nextTitle.textContent = labels[i] || '';   // owner 9 Oct: the label names the film on screen (was the next one)
      clearTimeout(timer);
      var v = vidOf(i);
      if (v && !paused) start(v); else if (!v) arm(9000);
      // warm up the next film only when this one is 60 % through (saves ~8 MB on a phone that leaves early); without a film: now
      var nv = vidOf((i + 1) % n);
      if (nv && nv !== v) {
        if (!v) nv.preload = 'auto';
        else { var warm = function () { if (v.duration && v.currentTime / v.duration > .6) { nv.preload = 'auto'; v.removeEventListener('timeupdate', warm); } }; v.addEventListener('timeupdate', warm); }
      }
    }
    function arm(ms) {
      clearTimeout(timer);
      if (paused || slides.length < 2) return;
      timer = setTimeout(function () { show(cur + 1); }, ms);
    }
    slides.forEach(function (s, k) {
      s.querySelectorAll('video').forEach(function (v) {
        v.addEventListener('ended', function () { if (k !== cur || paused) return; if (slides.length > 1) show(cur + 1); else start(v); });
      });
    });
    function setPaused(p) {
      paused = p;
      if (pauseBtn) { pauseBtn.classList.toggle('is-paused', p); pauseBtn.setAttribute('aria-label', p ? 'Afspil video' : 'Sæt video på pause'); }
      var v = vidOf(cur);
      if (p) { clearTimeout(timer); if (v) v.pause(); }
      else if (v) { var q = v.play(); if (q && q.catch) q.catch(function () { arm(9000); }); }
      else arm(9000);
    }
    root.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-v2-next')) show(cur + 1);
      else if (t.hasAttribute('data-v2-prev')) show(cur - 1);
      else if (t.hasAttribute('data-v2-goto')) show(+t.getAttribute('data-v2-goto'));
      else if (t.hasAttribute('data-v2-pause')) setPaused(!paused);
    });
    // hidden tab: stop the film; back: resume
    document.addEventListener('visibilitychange', function () { var v = vidOf(cur); if (!v) return; if (document.hidden) v.pause(); else if (!paused) playVid(v); });
    if (phone.addEventListener) phone.addEventListener('change', function () { show(cur); });
    show(0);
  }

  function initTabs(root) {
    if (root.dataset.v2Init) return; root.dataset.v2Init = '1';
    var tabs = root.querySelectorAll('[data-v2-tab]');
    var panels = root.querySelectorAll('[data-v2-panel]');
    var links = root.querySelectorAll('[data-v2-tablink]');
    var cur = 0;
    function pick(i, focus) {
      var n = tabs.length; if (!n) return;
      i = (i + n) % n; cur = i;
      for (var k = 0; k < n; k++) {
        var on = k === i;
        tabs[k].classList.toggle('is-on', on); tabs[k].setAttribute('aria-selected', on ? 'true' : 'false'); tabs[k].tabIndex = on ? 0 : -1;
        if (panels[k]) panels[k].hidden = !on;
        if (links[k]) links[k].classList.toggle('is-on', on);
      }
      if (focus) tabs[i].focus();
      if (tabs[i].scrollIntoView && tabs[i].parentNode.scrollWidth > tabs[i].parentNode.clientWidth) {
        var row = tabs[i].parentNode; row.scrollTo({ left: tabs[i].offsetLeft - row.offsetLeft - 20, behavior: reduce ? 'auto' : 'smooth' });
      }
      if (panels[i]) panels[i].scrollLeft = 0;
    }
    for (var k = 0; k < tabs.length; k++) tabs[k].tabIndex = k === 0 ? 0 : -1;
    root.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-v2-tab')) pick(+t.getAttribute('data-v2-tab'));
      else if (t.hasAttribute('data-v2-tabnext')) pick(cur + 1);
      else if (t.hasAttribute('data-v2-tabprev')) pick(cur - 1);
    });
    root.addEventListener('keydown', function (e) {
      if (!e.target.hasAttribute || !e.target.hasAttribute('data-v2-tab')) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); pick(cur + 1, true); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); pick(cur - 1, true); }
    });
  }

  function initShojin(root) {
    if (root.dataset.v2Init) return; root.dataset.v2Init = '1';
    var rit = root.querySelector('.v2-hs__ritv');
    if (rit && reduce) rit.pause();
    var cards = root.querySelectorAll('[data-v2-hsvid]');
    for (var i = 0; i < cards.length; i++) (function (c) {
      var v = c.querySelector('video'); if (!v) return;
      c.addEventListener('mouseenter', function () { if (reduce) return; if (rit) rit.pause(); c.classList.add('is-play'); playVid(v); });
      c.addEventListener('mouseleave', function () { c.classList.remove('is-play'); v.pause(); if (rit && !reduce) playVid(rit); });
    })(cards[i]);
  }

  function initSets(root) {
    if (root.dataset.v2Init) return; root.dataset.v2Init = '1';
    var st = {}; try { st = JSON.parse(root.querySelector('[data-v2-setdefaults]').textContent); } catch (e) {}
    var cat = 'pans';
    function q(sel) { return root.querySelectorAll(sel); }
    function render() {
      var c = st[cat] || { opt: '', sub: {} };
      q('[data-v2-cat]').forEach(function (b) { var on = b.getAttribute('data-v2-cat') === cat; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
      q('[data-v2-step2]').forEach(function (g) {
        var on = g.getAttribute('data-v2-step2') === cat; g.hidden = !on; if (!on) return;
        g.querySelectorAll('[data-v2-opt]').forEach(function (b) { var o = b.getAttribute('data-v2-opt') === c.opt; b.classList.toggle('is-on', o); if (b.hasAttribute('aria-checked')) b.setAttribute('aria-checked', o ? 'true' : 'false'); });
        var base = cat + '-' + c.opt;
        g.querySelectorAll('[data-v2-subfor]').forEach(function (s) {
          var show = s.getAttribute('data-v2-subfor') === base; s.hidden = !show;
          if (show && c.sub[base]) s.querySelectorAll('[data-v2-sub]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-v2-sub') === c.sub[base]); });
        });
      });
      var base = cat + '-' + c.opt;
      var key = c.sub[base] ? base + '-' + c.sub[base] : base;
      q('[data-v2-setmedia]').forEach(function (m) { m.hidden = m.getAttribute('data-v2-setmedia') !== key; });
      q('[data-v2-setbuy]').forEach(function (m) { m.hidden = m.getAttribute('data-v2-setbuy') !== key; });
      var soon = key === 'pans-5';
      var pp = root.querySelector('[data-v2-prom-price]'), ps = root.querySelector('[data-v2-prom-soon]');
      if (pp) pp.hidden = soon; if (ps) ps.hidden = !soon;
    }
    function count5() {
      var on = root.querySelectorAll('[data-v2-5pick].is-on');
      root.querySelectorAll('[data-v2-5count]').forEach(function (e) { e.textContent = on.length; });
      root.querySelectorAll('[data-v2-5pc]').forEach(function (p) { var b = root.querySelector('[data-v2-5pick="' + p.getAttribute('data-v2-5pc') + '"]'); p.hidden = !(b && b.classList.contains('is-on')); });
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b || !root.contains(b)) return;
      var c = st[cat];
      if (b.hasAttribute('data-v2-cat')) { cat = b.getAttribute('data-v2-cat'); render(); }
      else if (b.hasAttribute('data-v2-opt')) { c.opt = b.getAttribute('data-v2-opt'); render(); }
      else if (b.hasAttribute('data-v2-sub')) { c.sub[cat + '-' + c.opt] = b.getAttribute('data-v2-sub'); render(); }
      else if (b.hasAttribute('data-v2-5pick')) {
        var on = b.classList.contains('is-on');
        if (on && root.querySelectorAll('[data-v2-5pick].is-on').length === 1) return;
        b.classList.toggle('is-on', !on); b.setAttribute('aria-pressed', !on ? 'true' : 'false'); count5();
      } else if (b.hasAttribute('data-v2-5surf')) {
        var ti = b.getAttribute('data-v2-5surf') === 'ti';
        root.querySelectorAll('[data-v2-5surf]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        root.classList.toggle('is-ti', ti);
        var txt = ti ? 'Titanium Plasma · marts 2027' : 'Ventes nov.–dec. 2026';
        root.querySelectorAll('[data-v2-5status],[data-v2-5when]').forEach(function (x) { x.textContent = txt; });
      }
    });
    render(); count5();
  }

  /* one moving clip at a time on the page (home clips + recipe clips + the chef film) */
  var curClip = null;
  function playOnly(v) {
    if (curClip && curClip !== v) { curClip.pause(); var p0 = curClip.closest('[data-v2-ugc]'); if (p0) p0.classList.remove('is-play'); }
    curClip = v;
    if (!v) return;
    if (!v.src && v.getAttribute('data-src')) v.src = v.getAttribute('data-src');
    var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    var p = v.closest('[data-v2-ugc]'); if (p) p.classList.add('is-play');
  }

  function initKitchens(root) {
    if (root.dataset.v2Init) return; root.dataset.v2Init = '1';
    var slides = root.querySelectorAll('[data-v2-chef]');
    var thumbs = root.querySelectorAll('[data-v2-chefgo]');
    var num = root.querySelector('[data-v2-chefnum]');
    var cur = 0, n = slides.length;
    function go(i) {
      i = (i + n) % n; cur = i;
      slides.forEach(function (s, k) {
        var on = k === i; s.hidden = !on; s.classList.toggle('is-on', on);
        if (!on) { var v = s.querySelector('video'); if (v) { v.pause(); } }
      });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      if (num) num.textContent = '0' + (i + 1) + ' / 0' + n;
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.hasAttribute('data-v2-chefprev')) go(cur - 1);
      else if (b.hasAttribute('data-v2-chefnext')) go(cur + 1);
      else if (b.hasAttribute('data-v2-chefgo')) go(+b.getAttribute('data-v2-chefgo'));
      else if (b.hasAttribute('data-v2-chefplay')) {
        var box = b.closest('[data-v2-film]');
        var v = document.createElement('video');
        v.src = box.getAttribute('data-v2-film'); v.controls = true; v.playsInline = true; v.setAttribute('playsinline', '');
        v.poster = box.querySelector('img').currentSrc || box.querySelector('img').src;
        box.replaceChildren(v);
        if (curClip) { curClip.pause(); curClip = null; }
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      }
    });
  }

  function initHomeClips(root) {
    if (root.dataset.v2Init) return; root.dataset.v2Init = '1';
    var clips = root.querySelectorAll('[data-v2-ugc]');
    clips.forEach(function (c) {
      var v = c.querySelector('video');
      if (!reduce) c.addEventListener('mouseenter', function () { playOnly(v); });
      c.querySelector('[data-v2-ugcplay]').addEventListener('click', function () { if (curClip === v && !v.paused) { v.pause(); c.classList.remove('is-play'); } else playOnly(v); });
    });
    /* the first clip plays when the row comes into view (not on reduced motion) */
    if (!reduce && 'IntersectionObserver' in window && clips[0]) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && !curClip) playOnly(clips[0].querySelector('video')); if (!e.isIntersecting && curClip && root.contains(curClip)) { curClip.pause(); } }); }, { threshold: .4 });
      io.observe(root.querySelector('.v2-hhome__clips'));
    }
  }

  function initRecipes(root) {
    if (root.dataset.v2Init) return; root.dataset.v2Init = '1';
    if (reduce) return;
    root.querySelectorAll('[data-v2-rcvid]').forEach(function (a) {
      a.addEventListener('mouseenter', function () {
        var v = a.querySelector('video');
        if (!v) { v = document.createElement('video'); v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true'); v.setAttribute('data-src', a.getAttribute('data-v2-rcvid')); a.insertBefore(v, a.querySelector('.v2-hrc__shade')); }
        playOnly(v);
      });
      a.addEventListener('mouseleave', function () { var v = a.querySelector('video'); if (v) { v.pause(); if (curClip === v) curClip = null; } });
    });
  }

  function init(scope) {
    scope = scope || document;
    var h = scope.querySelectorAll('[data-v2-hero]'); for (var i = 0; i < h.length; i++) initHero(h[i]);
    var t = scope.querySelectorAll('[data-v2-tabs]'); for (var j = 0; j < t.length; j++) initTabs(t[j]);
    var s = scope.querySelectorAll('[data-v2-hs]'); for (var k = 0; k < s.length; k++) initShojin(s[k]);
    var z = scope.querySelectorAll('[data-v2-sets]'); for (var m = 0; m < z.length; m++) initSets(z[m]);
    scope.querySelectorAll('[data-v2-kitchens]').forEach(initKitchens);
    scope.querySelectorAll('[data-v2-home]').forEach(initHomeClips);
    scope.querySelectorAll('[data-v2-recipes]').forEach(initRecipes);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* owner 9 Oct (round 9): the front page uses the live site's hero slider (sections/custom-hero-slider). On desktop it is sized so
   the slider + »Shop efter kategori« fill the screen exactly and »Topvalg nu« starts just below the fold. */
(function () {
  function fitSlider() {
    var el = document.querySelector('.custom-hero-slider');
    if (!el) return;
    var sec = el.closest('.shopify-section') || el;
    if (window.innerWidth < 1000) { sec.style.removeProperty('--desktop-height'); return; }
    var next = sec.nextElementSibling;
    var cats = next ? next.querySelector('.v2-hc') : null;
    var catsH = cats ? Math.round(cats.getBoundingClientRect().height) : 0;
    var top = Math.round(el.getBoundingClientRect().top + window.scrollY);
    var h = window.innerHeight - top - catsH;
    sec.style.setProperty('--desktop-height', Math.max(520, Math.min(1100, h)) + 'px');
  }
  var t;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fitSlider); else fitSlider();
  window.addEventListener('load', fitSlider);
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fitSlider, 100); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitSlider);
})();
